module.exports = __webpack_public_path__ + "img/7.b26fd4c7.jpg";